import { useState, useCallback } from 'react';
import { captureException } from '@sentry/browser';

import { useLazyQuerySampleEvent, notify } from '@ion/api';

export default function useConfirmLoad({ loadSampleEvent, currentValue }) {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [pendingEvent, setPendingEvent] = useState(null);
  const [fetchSampleEvent] = useLazyQuerySampleEvent();

  const requestLoad = async selectedId => {
    const { data } = await fetchSampleEvent(selectedId);

    try {
      const { sampleEvent } = data;

      if (!currentValue || currentValue === sampleEvent.eventJson) {
        loadSampleEvent(sampleEvent);
      } else {
        setPendingEvent(sampleEvent);
        setIsConfirmModalOpen(true);
      }
    } catch (error) {
      captureException(error);

      notify.error({
        title: 'Sample Event Error',
        message: 'Failed to load the selected sample event, please try selecting the event again.',
      });
    }
  };

  const confirmLoad = useCallback(() => {
    if (pendingEvent) {
      loadSampleEvent(pendingEvent);
      setPendingEvent(null);
      setIsConfirmModalOpen(false);
    }
  }, [pendingEvent, loadSampleEvent]);

  const cancelLoad = useCallback(() => {
    setPendingEvent(null);
    setIsConfirmModalOpen(false);
  }, []);

  return {
    isConfirmModalOpen,
    requestLoad,
    confirmLoad,
    cancelLoad,
  };
}
